<template>
  <img class="img-fluid" :class="className" :src="renderImg" :alt="name" />
</template>

<script setup>
import { computed } from 'vue';
import useImage from '@global/composable/useImage';

const { imgTransfer } = useImage();

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  className: {
    type: String,
    default: '',
  },
});

const renderImg = computed(() => {
  return imgTransfer(props.url, props.size);
});
</script>
